import { SlotGameType1_21 } from '../SlotGameType1_21';

export class BurningFruits4021 extends SlotGameType1_21
{
}
